export default __webpack_public_path__ + "static/media/arrow_drop_up_24px.9bb59625.svg";